import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk, RootState } from '../../app/store';
import { IDaasSignup } from '../../services/DaasSignupService';

type SignupState = {
  step: number;
  signup: IDaasSignup;
};

const initState: IDaasSignup = {
  email: '',
  applicationId: '',
  redirectUri: '',
};

const initialState: SignupState = {
  step: 0,
  signup: initState,
};

export const slice = createSlice({
  name: 'signup',
  initialState,
  reducers: {
    init: (state, action: PayloadAction<IDaasSignup>) => {
      state.signup = action.payload;
    },
    setEmail: (state, action: PayloadAction<string>) => {
      state.signup.email = action.payload;
      state.step = 1;
    },
    setNewsletterOptin: (state, action: PayloadAction<boolean>) => {
      state.signup.newsletterOptin = action.payload;
    },
    incrementStep: (state, action: PayloadAction<number>) => {
      state.step = action.payload;
    },
    decrementStep: (state, action: PayloadAction<number>) => {
      state.step = action.payload;
    },
    reset: (state) => {
      state.step = 0;
      state.signup = Object.assign({}, initState);
    },
  },
});

export const { init, setEmail, incrementStep, setNewsletterOptin, decrementStep, reset } = slice.actions;

export const setSignupEmail =
  (email: string): AppThunk =>
    (dispatch) => {
      dispatch(setEmail(email));
    };

export const setSignupNewsletterOptin =
  (optin: boolean): AppThunk =>
    (dispatch) => {
      dispatch(setNewsletterOptin(optin));
    };

export const incrementSignupStep =
  (step: number): AppThunk =>
    (dispatch) => {
      dispatch(incrementStep(step));
    };

export const decrementSignupStep =
  (step: number): AppThunk =>
    (dispatch) => {
      dispatch(decrementStep(step));
    };

export const initSignup =
  (initSignup: IDaasSignup): AppThunk =>
    (dispatch) => {
      dispatch(init(initSignup));
    };

export const resetSignup = (): AppThunk => (dispatch) => {
  dispatch(reset());
};

export const selectStep = (state: RootState) => state.signup.step;
export const selectSignup = (state: RootState) => state.signup.signup;
export const selectSignupEmail = (state: RootState) => state.signup.signup.email;

export default slice.reducer;
